import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import LegalPageLayout from "./LegalPageLayout";

const content = {
  fr: {
    title: "Règles du Marketplace",
    sections: [
      {
        title: "Règles générales",
        items: [
          "Les annonces doivent être honnêtes et précises",
          "Les photos doivent représenter fidèlement le produit",
          "Le prix affiché doit être le prix réel de vente",
          "Une seule annonce par produit",
        ],
      },
      {
        title: "Articles interdits",
        items: [
          "Produits contrefaits ou volés",
          "Armes et munitions",
          "Drogues et substances illicites",
          "Animaux vivants (sauf exceptions)",
          "Produits dangereux ou toxiques",
          "Contenus pour adultes",
        ],
      },
      {
        title: "Transactions",
        text: "LëtzServices est une plateforme de mise en relation. Les transactions s'effectuent directement entre acheteurs et vendeurs. Nous recommandons de privilégier les rencontres en personne et le paiement en espèces pour les transactions locales.",
      },
      {
        title: "Comportement",
        items: [
          "Restez courtois dans vos échanges",
          "Répondez aux messages dans un délai raisonnable",
          "Honorez vos engagements de vente/achat",
          "Signalez tout comportement suspect",
        ],
      },
      {
        title: "Sanctions",
        text: "Le non-respect de ces règles peut entraîner la suppression de l'annonce, la suspension temporaire ou définitive du compte.",
      },
    ],
  },
  en: {
    title: "Marketplace Rules",
    sections: [
      {
        title: "General Rules",
        items: [
          "Listings must be honest and accurate",
          "Photos must accurately represent the product",
          "The displayed price must be the actual selling price",
          "One listing per product",
        ],
      },
      {
        title: "Prohibited Items",
        items: [
          "Counterfeit or stolen products",
          "Weapons and ammunition",
          "Drugs and illegal substances",
          "Live animals (with exceptions)",
          "Dangerous or toxic products",
          "Adult content",
        ],
      },
      {
        title: "Transactions",
        text: "LëtzServices is a connection platform. Transactions are made directly between buyers and sellers. We recommend in-person meetings and cash payments for local transactions.",
      },
      {
        title: "Behavior",
        items: [
          "Be courteous in your exchanges",
          "Respond to messages within a reasonable time",
          "Honor your sale/purchase commitments",
          "Report any suspicious behavior",
        ],
      },
      {
        title: "Sanctions",
        text: "Non-compliance with these rules may result in listing removal, temporary or permanent account suspension.",
      },
    ],
  },
};

const MarketplaceRulesPage = () => {
  const { lang } = useLanguage();
  return <LegalPageLayout content={content[lang] || content.fr} />;
};

export default MarketplaceRulesPage;
